import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { ActionItem, BaseContainer } from '@stylehaven/components';
import { ReduceVisibleActionItems } from '../../../helpers';
import { RecordActionItem } from '../../../record/entities/action/record-action-item.class';
import { ApiFragment } from '../../../record/entities/api-fragment.entity';

@Component({
    standalone: false,
    selector: 'digihaven-record-action-group',
    templateUrl: './record-action-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DigihavenRecordActionGroupComponent extends BaseContainer implements OnInit {
    recordActionItems$: ReplaySubject<RecordActionItem<ApiFragment>[]> = new ReplaySubject<
        RecordActionItem<ApiFragment>[]
    >(1);

    record$: ReplaySubject<ApiFragment> = new ReplaySubject<ApiFragment>(1);

    actionItems$!: Observable<ActionItem[]>;

    @Input() set recordActionItems(recordActionItems: RecordActionItem<ApiFragment>[]) {
        if (recordActionItems) {
            this.recordActionItems$.next(recordActionItems);
        }
    }

    @Input() set record(record: ApiFragment) {
        if (record) {
            this.record$.next(record);
        }
    }

    ngOnInit(): void {
        this.actionItems$ = combineLatest([this.record$, this.recordActionItems$]).pipe(
            switchMap(([record, recordActionItems]) => {
                const actionItems$ = recordActionItems.map(recordActionItem => recordActionItem.toActionItem(record));
                return combineLatest(actionItems$);
            }),
            map(actionItems => ReduceVisibleActionItems(actionItems))
        );
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.recordActionItems$.complete();
        this.record$.complete();
    }
}
